import { IACDLEvent } from '../../../../../services/eventBus.service';

export const WorkspaceTimeZoneUpdatedEventType = Symbol('WORKSPACE_TIMEZONE_UPDATED_EVENT');

export class WorkspaceTimeZoneUpdatedEvent implements IACDLEvent {
  constructor(
    public readonly workspaceId: string,
    public readonly timezone: number
  ) {}

  readonly type: symbol = WorkspaceTimeZoneUpdatedEventType;
}
